import { C, t } from '../constants/dashboardConstants';

/**
 * 메시지 수신 허용 (제작사 전용)
 *
 * 꺼두면 '처음 연락하는' 배우가 대화를 시작할 수 없다.
 * 이미 대화가 있거나 제작사가 먼저 연락한 배우와는 그대로 주고받는다 —
 * 이 판정은 서버가 하고, 여기서는 안내만 한다.
 */
export default function ReceiveToggle({ checked, busy, onChange }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
      <span style={t('16px', 500, C.bk)}>메시지 수신 허용</span>

      <button
        role="switch"
        aria-checked={checked}
        aria-label="메시지 수신 허용"
        onClick={() => !busy && onChange(!checked)}
        disabled={busy}
        style={{
          width: 52, height: 28, borderRadius: 999, border: 'none', padding: 0,
          position: 'relative', flexShrink: 0,
          background: checked ? C.point : C.g200,
          cursor: busy ? 'default' : 'pointer',
          opacity: busy ? 0.6 : 1,
          transition: 'background .18s',
        }}
      >
        <span style={{
          position: 'absolute', top: 3, left: checked ? 27 : 3,
          width: 22, height: 22, borderRadius: '50%', background: C.white,
          transition: 'left .18s', boxShadow: '0 1px 4px rgba(0,0,0,0.28)',
        }} />
      </button>

      <span style={t('14px', 400, C.sub)}>
        {checked
          ? '모든 배우가 새 대화를 시작할 수 있습니다.'
          : '기존에 대화한 배우만 메시지를 보낼 수 있습니다.'}
      </span>
    </div>
  );
}
